import { render } from "./WorkExperienceSection.vue?vue&type=template&id=2f728971&lang=true"
import script from "./WorkExperienceSection.vue?vue&type=script&lang=js"
export * from "./WorkExperienceSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__